/**
 * Wishlist – Pitstopstore
 * localStorage-based wishlist (no login required)
 */

;(function () {
  'use strict';

  // ─── Storage layer ─────────────────────────────────────────────────────────
  var STORAGE_KEY = 'pitstop_wishlist_v1';

  var WishlistStore = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    },
    save: function (items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('wishlist:updated', {
        bubbles: true,
        detail: { count: items.length, items: items }
      }));
    },
    add: function (item) {
      var items = this.get();
      if (!items.find(function (i) { return i.id === item.id; })) {
        items.push(item);
        this.save(items);
        return true;
      }
      return false;
    },
    remove: function (id) {
      var items = this.get().filter(function (i) { return i.id !== id; });
      this.save(items);
    },
    toggle: function (item) {
      if (this.has(item.id)) { this.remove(item.id); return false; }
      this.add(item); return true;
    },
    has: function (id) {
      return this.get().some(function (i) { return i.id === id; });
    },
    count: function () { return this.get().length; }
  };

  // expose globally so Liquid/other scripts can access it
  window.WishlistStore = WishlistStore;

  // ─── Header count badge ────────────────────────────────────────────────────
  function updateCountBadge(count) {
    document.querySelectorAll('.wishlist-header-count').forEach(function (el) {
      el.textContent = count;
      // Zähler bleibt immer sichtbar – auch bei 0, genau wie der Warenkorb-Zähler.
      el.style.removeProperty('display');
    });
  }

  document.addEventListener('wishlist:updated', function (e) {
    updateCountBadge(e.detail.count);
    syncHearts();
  });

  // ─── Heart button state ────────────────────────────────────────────────────
  function setHeartState(btn, active) {
    var activeColor  = btn.dataset.activeColor  || '#E53E3E';
    var inactiveColor = btn.dataset.inactiveColor || 'currentColor';
    var svg = btn.querySelector('svg');
    if (!svg) return;
    if (active) {
      svg.setAttribute('fill', activeColor);
      svg.setAttribute('stroke', activeColor);
    } else {
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', inactiveColor);
    }
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Aus Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
  }

  // Setzt den optischen Zustand aller aktuell im DOM vorhandenen Herzen.
  // Wird auch nach jeder Änderung aufgerufen, damit mehrere Herzen zum selben
  // Produkt (Produktseite + Produktkacheln) synchron bleiben.
  function syncHearts(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      setHeartState(btn, WishlistStore.has(parseInt(btn.dataset.productId, 10)));
    });
  }

  function initHearts() {
    syncHearts();

    // Ein einziger delegierter Listener am document statt einer Bindung pro Button.
    // Nötig, weil Abschnitte wie "Related products", "Recently viewed products"
    // und die Schnellansicht ihre Produktkacheln erst nach DOMContentLoaded über
    // die Section Rendering API nachladen – deren Herzen bekamen vorher nie einen
    // Klick-Handler. Capture-Phase, damit der Klick nicht vorher von einem
    // Handler auf der Produktkachel abgefangen wird.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      WishlistStore.toggle({
        id:         parseInt(btn.dataset.productId, 10),
        handle:     btn.dataset.productHandle,
        title:      btn.dataset.productTitle,
        price:      parseInt(btn.dataset.productPrice, 10),
        image:      btn.dataset.productImage,
        variant_id: parseInt(btn.dataset.variantId, 10),
        url:        btn.dataset.productUrl
      });
      // Zustandswechsel erfolgt über das 'wishlist:updated'-Event -> syncHearts()
    }, true);

    // Nachgeladene Produktkacheln: Herzen sofort auf den gespeicherten Stand bringen,
    // damit bereits gemerkte Produkte auch dort rot erscheinen.
    if (window.MutationObserver && document.body) {
      var pending = false;
      new MutationObserver(function (mutations) {
        if (pending) return;
        var hasNewHeart = mutations.some(function (m) {
          return Array.prototype.some.call(m.addedNodes, function (n) {
            return n.nodeType === 1 &&
              (n.hasAttribute('data-wishlist-toggle') || n.querySelector('[data-wishlist-toggle]'));
          });
        });
        if (!hasNewHeart) return;
        // setTimeout statt requestAnimationFrame: rAF läuft in nicht sichtbaren
        // Tabs nicht, dadurch bliebe die Sperre hängen und der Abgleich aus.
        pending = true;
        setTimeout(function () { pending = false; syncHearts(); }, 0);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  // ─── Wishlist page ─────────────────────────────────────────────────────────
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || 'CHF {{amount}}';
    return fmt
      .replace('{{amount}}', (cents / 100).toFixed(2))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    var url = (window.routes && window.routes.cartAddUrl) || '/cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
      btn.disabled = false;
    })
    .catch(function () { btn.disabled = false; });
  }

  // ─── Gewerbe-Sperre ────────────────────────────────────────────────────────
  // Gewerbeartikel dürfen nur von Gewerbekunden in den Warenkorb gelegt werden.
  // Das Herz wird für gesperrte Artikel gar nicht erst gerendert (siehe
  // product-item.liquid / wishlist-heart.liquid). Artikel, die bereits vorher
  // gemerkt wurden, liegen aber weiterhin im localStorage – die werden hier
  // erkannt und auf der Wunschlisten-Seite gesperrt.
  var GewerbeGate = {
    active: false,          // nur true, wenn Sperre aktiv UND Kunde kein Gewerbekunde
    productTags: [],
    lockedTitle: '',
    contactUrl: '',
    contactLabel: '',
    cache: {},              // handle -> true (gesperrt) / false (frei)

    init: function (container) {
      this.active = container.dataset.gewerbeEnabled === 'true' &&
                    container.dataset.customerGewerbe !== 'true';
      this.productTags = (container.dataset.gewerbeProductTags || 'Gewerbe')
        .split(',').map(function (t) { return t.trim().toLowerCase(); })
        .filter(function (t) { return t.length; });
      this.lockedTitle  = container.dataset.gewerbeLockedTitle  || '🔒 Nur für Gewerbekunden verfügbar.';
      this.contactUrl   = container.dataset.gewerbeContactUrl   || '/pages/gewerbekontakt';
      this.contactLabel = container.dataset.gewerbeContactLabel || 'Jetzt als Gewerbekunde anfragen →';
    },

    // Unbekannt gilt als gesperrt (fail closed) – so erscheint nie kurzzeitig
    // ein freigeschalteter Warenkorb-Button, bevor die Prüfung durch ist.
    isRestricted: function (item) {
      if (!this.active) return false;
      return this.cache[item.handle] !== false;
    },

    // Prüft alle noch unbekannten Artikel gegen die Produkt-Tags aus /products/<handle>.js
    resolve: function (items) {
      var self = this;
      var offen = items.filter(function (i) {
        return i.handle && !(i.handle in self.cache);
      });
      if (!offen.length) return null;

      return Promise.all(offen.map(function (item) {
        return fetch('/products/' + item.handle + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || !data.tags) { self.cache[item.handle] = true; return; }
            var tags = data.tags.map(function (t) { return String(t).trim().toLowerCase(); });
            self.cache[item.handle] = self.productTags.some(function (needle) {
              return tags.indexOf(needle) !== -1;
            });
          })
          .catch(function () { self.cache[item.handle] = true; });
      }));
    }
  };

  function renderWishlistPage() {
    var container = document.getElementById('wishlist-items-container');
    if (!container) return;

    var items       = WishlistStore.get();
    var emptyState  = document.getElementById('wishlist-empty-state');
    var filledState = document.getElementById('wishlist-filled-state');

    document.querySelectorAll('.wishlist-item-count').forEach(function (el) {
      el.textContent = items.length;
    });

    if (items.length === 0) {
      if (emptyState)  emptyState.style.display  = '';
      if (filledState) filledState.style.display = 'none';
      return;
    }
    if (emptyState)  emptyState.style.display  = 'none';
    if (filledState) filledState.style.display = '';

    var removeColor      = container.dataset.removeColor      || '#1a1a1a';
    var addCartColor     = container.dataset.addCartColor     || '#1a1a1a';
    var addCartTextColor = container.dataset.addCartTextColor || '#ffffff';

    // Gesperrte Gewerbeartikel ermitteln; sobald das Ergebnis da ist, neu rendern.
    var offen = GewerbeGate.active ? GewerbeGate.resolve(items) : null;
    if (offen) offen.then(renderWishlistPage);

    container.innerHTML = items.map(function (item) {
      var gesperrt = GewerbeGate.isRestricted(item);
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" class="wishlist-item__img" loading="lazy">'
        : '<div class="wishlist-item__img wishlist-item__img--placeholder"></div>';
      return [
        '<div class="wishlist-item" data-id="' + item.id + '"' + (gesperrt ? ' data-gewerbe-locked="true"' : '') + '>',
          '<a href="' + item.url + '" class="wishlist-item__image-wrap">' + imgHtml + '</a>',
          '<div class="wishlist-item__info">',
            '<a href="' + item.url + '" class="wishlist-item__title">' + item.title + '</a>',
            '<p class="wishlist-item__price">' + formatMoney(item.price) + '</p>',
            gesperrt
              ? '<p class="wishlist-item__gewerbe-locked" style="margin:4px 0 0;font-size:0.85rem;line-height:1.4;">' +
                  '<strong>' + GewerbeGate.lockedTitle + '</strong><br>' +
                  '<a href="' + GewerbeGate.contactUrl + '" style="color:#FF6128;text-decoration:underline;">' + GewerbeGate.contactLabel + '</a>' +
                '</p>'
              : '',
          '</div>',
          '<div class="wishlist-item__actions">',
            gesperrt ? '' : [
              '<button class="wishlist-item__add-to-cart" data-variant-id="' + item.variant_id + '" ',
                'style="background:' + addCartColor + ';color:' + addCartTextColor + ';" ',
                'aria-label="In den Warenkorb">',
                '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">',
                  '<path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>',
                '</svg>',
              '</button>'
            ].join(''),
            '<button class="wishlist-item__remove" data-id="' + item.id + '" ',
              'style="background:' + removeColor + ';" ',
              'aria-label="Aus Wunschliste entfernen">',
              '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">',
                '<polyline points="3 6 5 6 21 6"/>',
                '<path d="M19 6l-1 14H6L5 6"/>',
                '<path d="M10 11v6"/>',
                '<path d="M14 11v6"/>',
                '<path d="M9 6V4h6v2"/>',
              '</svg>',
            '</button>',
          '</div>',
        '</div>'
      ].join('');
    }).join('');

    // Bind remove buttons
    container.querySelectorAll('.wishlist-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        WishlistStore.remove(parseInt(this.dataset.id, 10));
        renderWishlistPage();
      });
    });

    // Bind add-to-cart buttons
    container.querySelectorAll('.wishlist-item__add-to-cart').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(this.dataset.variantId, this);
      });
    });
  }

  function initWishlistPage() {
    var container = document.getElementById('wishlist-items-container');
    if (!container) return;

    GewerbeGate.init(container);
    renderWishlistPage();
    document.addEventListener('wishlist:updated', renderWishlistPage);

    // "Add all to cart" button
    var addAllBtn = document.getElementById('wishlist-add-all-btn');
    if (!addAllBtn) return;
    addAllBtn.addEventListener('click', function () {
      // Gesperrte Gewerbeartikel werden übersprungen.
      var items = WishlistStore.get().filter(function (item) {
        return !GewerbeGate.isRestricted(item);
      });
      if (!items.length) return;
      this.disabled = true;
      var self = this;
      var cartUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add.js';

      // Nacheinander statt parallel: /cart/add.js arbeitet auf genau einem
      // Warenkorb pro Sitzung. Gleichzeitig abgeschickte Anfragen gehen vom
      // selben Ausgangsstand aus und überschreiben sich gegenseitig – dadurch
      // landete nur ein Teil der Artikel im Warenkorb.
      var queue = Promise.resolve();
      items.forEach(function (item) {
        queue = queue.then(function () {
          return fetch(cartUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: item.variant_id, quantity: 1 })
          }).catch(function () {
            // Ein einzelner Fehlschlag (z. B. ausverkaufte Variante) darf die
            // übrigen Artikel nicht blockieren.
          });
        });
      });

      queue.then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { scrollToTop: false }
        }));
        self.disabled = false;
      });
    });
  }

  // ─── Inject base CSS ───────────────────────────────────────────────────────
  (function injectStyles() {
    var style = document.createElement('style');
    style.id = 'wishlist-base-styles';
    style.textContent = [
      /* ensure card hearts are positioned correctly */
      '.product-item{position:relative;}',
      '.product-item__wishlist-btn:hover{transform:scale(1.12);}'
    ].join('');
    document.head.appendChild(style);
  })();

  // ─── Init ──────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    updateCountBadge(WishlistStore.count());
    initHearts();
    initWishlistPage();
  });

})();
